<script setup>
defineProps({
    title: {
        type: String,
        required: true,
    },
    subtitle: {
        type: String,
        default: null,
    },
});
</script>

<template>
    <!--
        Desktop: full-bleed band across the dashboard panel (the sidebar
        overlaps it from below). Mobile: inset rounded card above the tabs.
        Both use a single flat export of the gradient + photo-circle cluster.
    -->
    <section
        class="relative h-[141px] overflow-hidden rounded-brand md:-mx-7 md:-mt-7 md:h-[171px] md:rounded-none"
    >
        <img
            :src="asset('images/friends/hero-mobile.png')"
            alt=""
            aria-hidden="true"
            class="absolute inset-0 h-full w-full object-cover md:hidden"
        />
        <!-- max-md:hidden (not `hidden md:block`): legacy .hidden is !important on pages that load app.scss -->
        <img
            :src="asset('images/friends/hero-desktop.png')"
            alt=""
            aria-hidden="true"
            class="absolute inset-0 h-full w-full object-cover max-md:hidden"
        />

        <div
            class="relative flex h-full flex-col justify-center px-4 md:pl-[444px] md:pr-10"
        >
            <h1
                class="font-brand-display text-[22px] font-black italic uppercase leading-none tracking-[-0.01em] text-white md:text-[32px]"
            >
                {{ title }}
            </h1>
            <p
                v-if="subtitle"
                class="mt-2 max-w-[220px] font-brand text-[13px] font-medium leading-snug text-white sm:max-w-none md:text-[15px]"
            >
                {{ subtitle }}
            </p>
        </div>
    </section>
</template>
